import classes from "./NavToggleBtn.module.css";

export function NavToggleButton({ onClick, text, isActive }) {
  return (
    <button
      className={isActive ? classes.active : classes.btn}
      onClick={onClick}
    >
      {text}
    </button>
  );
}
